"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileDefaultCTABanner = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const web_sds_c_1 = require("@snapchat/web-sds-c");
const index_1 = require("../index");
const attribution_1 = require("../../attribution");
const MobileDefaultCTABanner_module_css_1 = __importDefault(require("./MobileDefaultCTABanner.module.css"));
/**
 * Default CTA Banner
 */
function MobileDefaultCTABanner({ downloadLink, link, onClick, openInSnapchatLink, }) {
    return ((0, jsx_runtime_1.jsx)("div", { className: MobileDefaultCTABanner_module_css_1.default.container, children: (0, jsx_runtime_1.jsx)(web_sds_c_1.ColoredButton, { color: web_sds_c_1.ButtonColor.YELLOW, link: (0, attribution_1.getMobileAttributionLink)({
                oneLink: link,
                openInAppLink: openInSnapchatLink,
                downloadLink,
            }), onClick: onClick, children: (0, jsx_runtime_1.jsx)(index_1.CTABannerMessage, { openInSnapchatLink: openInSnapchatLink }) }) }));
}
exports.MobileDefaultCTABanner = MobileDefaultCTABanner;
//# sourceMappingURL=MobileDefaultCTABanner.js.map